import * as React from "react";

const PlayIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="6,4 20,12 6,20" />
        </svg>
    );
};

export default React.memo(PlayIcon);
